module.exports = __webpack_public_path__ + "static/product-pc-content-5-ff26663e75a1c4a696064e25b82ee58f.jpg";